import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/libs/components/Blog/BlogTag/BlogTag.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/libs/components/Blog/BlogTitleSubtitle/BlogTitleSubtitle.js");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedPostUpdate"] */ "/usr/src/app/libs/components/FeaturedPostUpdate/FeaturedPostUpdate.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/libs/components/StyledIcon/index.jsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/libs/components/Subscribe/Subscribe.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/sites/wpspotlight.pro/src/components/global/animation-container.tsx");
